import { isCampaignEnabled } from '../../jsCore/config/campaignConfig'
import { external as externalScriptLoader } from '../../jsCore/utils/script'
import { externalScriptsConfig } from '../../jsCore/organizedByType/config/externalScripts'
import { register } from '../../components/viewability/viewbilityTracker'
import { getCountryCode } from '../../jsCore/providers/geolocationProvider'

const FRESH_EIGHT_CONFIG_CLIENTE = {
  whiteListCountryCodes: ['IL', 'US'],
  pageTypes: ['post'],
  isEmbedded: false,
  daysWhiteList: [0, 1, 2, 3, 4, 5, 6],
  isSlideshow: false,
  featureId: 'Fresh8',
  blacklistedCategories: ['sponsored'],
  whitelistedCategories: [],
  placeHolder: 'injectedScriptWidget',
  externalScriptSrc: 'arcadium.src',
  externalScriptName: 'arcadium',
  id: 'inhabit-placement',
}

var freshEightCampaigns = [FRESH_EIGHT_CONFIG_CLIENTE]

function addPlaceHolder(campaign) {
  let paragraph = document.querySelectorAll('.post-content > p')[2]
  if (paragraph !== undefined && paragraph !== null) {
    paragraph.insertAdjacentHTML(
      'afterEnd',
      `<div class=${campaign.placeHolder} id=${campaign.id} data-viewability_category="Article page" data-viewability_action="widget viewable impression" 
        data-viewability_label=${campaign.externalScriptName}></div>`
    )
  }
}

function getScript(campaign) {
  return getCountryCode().then(response => {
    if (campaign.whiteListCountryCodes.includes(response)) {
      return { src: externalScriptsConfig.arcadium.src, name: externalScriptsConfig.arcadium.name }
    }
    return null
  })
}

function injectScript(campaign) {
  return getScript(campaign).then(response => {
    externalScriptLoader.load({
      config: {
        src: response.src,
        name: response.name,
        'data-ark-client': 'a268b4f3-fdcc-4592-9b09-1a320afac987',
      },
      loadNow: true,
    })
  })
}

export function injectFreshEight() {
  freshEightCampaigns.forEach(campaign => {
    isCampaignEnabled(campaign).then(response => {
      if (response.isCampaignEnabled) {
        addPlaceHolder(campaign)
        injectScript(campaign)
        register('.' + campaign.placeHolder)
      }
    })
  })
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/fresh8/freshEightInjector.js